/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const DebtReportPage = lazyLoad(
  () => import('./index'),
  module => module.DebtReportPage
);
